export default "__VITE_ASSET__DHkazvxb__"